export default "__VITE_ASSET__DgkDE1tz__"